import { ESearchBlockView } from '../../types/searchBlockView';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum ESearchBlockViewActionType {
  SetSearchBlockView = 'searchBlockView/setSearchBlockView',
}

export type TSetSearchBlockView = ITypedReduxAction<ESearchBlockViewActionType.SetSearchBlockView, ESearchBlockView>;

export type TSearchBlockViewActions = TSetSearchBlockView;
